var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChkRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xB2\xB4\xED\x81\xAC\xEA\xB2\xBD\xEA\xB3\xA0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M8 15.3451L4 11.3451L5.4 9.94507L8 12.5451L14.6 5.94507L16 7.34507L8 15.3451Z",
    fill: "#FF3062"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChkRed);
export default __webpack_public_path__ + "static/media/ic_chk_red.c89c103b09eb60bfb93d81bf85964464.svg";
export { ForwardRef as ReactComponent };